import React, { useState } from "react";
import Sidebar from "./Sidebar/Sidebar";
import Topbar from "./Sidebar/Topbar";

const Wrapper = (props) => {
  const [inactive, setInactive] = useState(false);

  return (
    <>
      <div className="wrapper">
        <Topbar />
        <div className={`body-overlay ${inactive ? "inactive" : ""} `}></div>
        <Sidebar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
        />
        <div className={`page-wrapper ${inactive ? "inactive" : ""}`}>
          {props.children}
        </div>
      </div>
    </>
  );
};
export default Wrapper;
